/* eslint-disable no-param-reassign */
import axios from 'axios';
import Vue from 'vue';
import Swal from 'sweetalert2';
import * as Constants from '../constants';

// create the http object
const http = axios.create({
  baseURL: `${process.env.API_HOST}`,
  crossDomain: true,
  timeout: 20000,
  withCredentials: true
});

let isRefreshing = false;
const isTokenGoingToExpire = () => {
  if (!Vue.$jwt.hasToken()) return false;
  const now = new Date();
  const nowInSeconds = now.getTime() / 1000;
  const tokenExpireInSeconds = Vue.$jwt.decode().exp;
  const minutesTillExpire = (tokenExpireInSeconds - nowInSeconds) / 60;
  return minutesTillExpire >= 0 && minutesTillExpire < 30;
};

const refreshToken = () => {
  return new Promise((resolve, reject) => {
    const config = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: Vue.$jwt.hasToken() ? `Bearer ${Vue.$jwt.getToken()}` : ''
      }
    };

    if (!isRefreshing) {
      isRefreshing = true;
      http.get(Constants.AUTHENTICATION_RENEW_URL(), config)
        .then((res) => {
          isRefreshing = false;
          const token = res.data.data.token;
          localStorage.setItem('user-token', token);
          const user = res.data.data.user;
          localStorage.setItem('dynatrace-usertag', user.fullName);
          resolve(token);
        })
        .catch((err) => {
          isRefreshing = false;
          reject(err);
        });
    } else {
      resolve();
    }
  });
};

http.interceptors.request.use((request) => {
  const originalRequest = request;
  const token = Vue.$jwt.getToken();

  if (!isTokenGoingToExpire()) {
    if (token !== null) {
      request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
  }

  return refreshToken()
    .then((res) => {
      const token2 = res || token;
      originalRequest.headers.Authorization = `Bearer ${token2}`;

      return originalRequest;
    });
}, (error) => {
  return Promise.reject(error);
});

http.interceptors.response.use((response) => {
  return response;
}, (err) => {
  if (err.response.status === 401) {
    if (err.response.data.message === 'jwt expired') {
      Swal.fire(
        {
          type: 'error',
          title: 'JWT Token Expired',
          text: 'Your JWT Token has Expired.  Click \'OK\' to login again.',
          allowOutsideClick: false,
          onClose: () => {
            // clear local storage
            localStorage.clear();
            // redirect to login page
            window.location.href = '/';
          }
        }
      );
    }
  }
  return Promise.reject(err);
});

export default {
  get(url, options) {
    return http.get(url, options);
  },
  post(url, body) {
    return http.post(url, body);
  },
  put(url, body) {
    return http.put(url, body);
  },
  delete(url) {
    return http.delete(url);
  }
};



// WEBPACK FOOTER //
// ./src/utils/api.js